module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "menu-item",
    class: [
      _vm.selected ? 'menu-item-current' : '',
      _vm.icon ? 'menu-item-icon' : ''
    ],
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "icon iconfont",
    class: [_vm.icon ? 'icon-' + _vm.icon : '']
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.tip) ? _c('span', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.tip))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8114523e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/sidebar-item.vue
// module id = 271
// module chunks = 36